<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="会员介绍图片：" prop="userMemberPicture">
        <upload-img :fileList="userMemberPictureList" :imgWhich="8" warmTxt="建议尺寸：702*324px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="会员升级说明：" prop="memberUpgradeDesc">
        <editor :value="ruleForm.memberUpgradeDesc" :height="350" v-model="ruleForm.memberUpgradeDesc"></editor>
      </el-form-item>
      <el-form-item label="内部员工升级说明：" prop="employeeUpgradeDesc">
        <editor :value="ruleForm.employeeUpgradeDesc" :height="350" v-model="ruleForm.employeeUpgradeDesc"></editor>
      </el-form-item>
      <el-form-item label="合伙人升级说明：" prop="partnerUpgradeDesc">
        <editor :value="ruleForm.partnerUpgradeDesc" :height="350" v-model="ruleForm.partnerUpgradeDesc"></editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveOrUpdateShopConfig, fetchShopConfigDetail } from '@/api/shop'
export default {
  name: 'Vip',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      ruleForm: {
        userMemberPicture:'',
        memberUpgradeDesc:'',
        employeeUpgradeDesc:"",
        partnerUpgradeDesc:''
      },
      userMemberPictureList:[]
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    var that = this;
    fetchShopConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        if(data.userMemberPicture != ''){
          that.userMemberPictureList.push({url: data.userMemberPicture})
        }
        that.ruleForm.userMemberPicture = data.userMemberPicture
        that.ruleForm.memberUpgradeDesc = data.memberUpgradeDesc
        that.ruleForm.employeeUpgradeDesc = data.employeeUpgradeDesc
        that.ruleForm.partnerUpgradeDesc = data.partnerUpgradeDesc
      }
    })
  },
  methods: {
    imgUrlBtn(backData){
       // 会员介绍图片
        this.ruleForm.userMemberPicture = backData.imgUrl;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let userMemberPicture = that.ruleForm.userMemberPicture
      let memberUpgradeDesc = that.ruleForm.memberUpgradeDesc
      let employeeUpgradeDesc = that.ruleForm.employeeUpgradeDesc
      let partnerUpgradeDesc = that.ruleForm.partnerUpgradeDesc
      that.fullscreenLoading = true
      saveOrUpdateShopConfig({userMemberPicture:userMemberPicture,memberUpgradeDesc:memberUpgradeDesc,employeeUpgradeDesc:employeeUpgradeDesc,partnerUpgradeDesc:partnerUpgradeDesc}).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/Vip.vue